import { useUser } from "lib/user"
import type { DeliveryTypeEnum } from "@shared/graphql.types"

export function useDeliveryType(): DeliveryTypeEnum {
  const user = useUser()

  if (!user?.deliveryType) {
    return "standard"
  }

  const { deliveryType } = user

  return deliveryType
}
